export default __webpack_public_path__ + "static/media/gasag_s1.3552d054.png";